import { z } from "zod";
import { TaskAttemptVersion } from "@remi/enums/task-attempt-version";

export const EstimateCreatedV1DataSchema = z.object({
  version: z.literal(TaskAttemptVersion.v1),
  estimateId: z.string(),
});
export type EstimateCreatedV1Data = z.infer<typeof EstimateCreatedV1DataSchema>;

const EstimateSubmittedV1AcceptedSchema = z.object({
  attemptType: z.literal("ACCEPTED"),
});

const EstimateSubmittedV1RejectedSchema = z.object({
  attemptType: z.literal("REJECTED"),
  rejectionReason: z.string().max(2000),
});

export const EstimateSubmittedV1DataSchema = z.object({
  version: z.literal(TaskAttemptVersion.v1),
  payload: z.discriminatedUnion("attemptType", [EstimateSubmittedV1AcceptedSchema, EstimateSubmittedV1RejectedSchema]),
});
export type EstimateSubmittedV1Data = z.infer<typeof EstimateSubmittedV1DataSchema>;
